import { useState, useEffect, useCallback } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import {
  productIdAtom,
  productImagesAtom,
  productVariantsAtom
} from 'global/store';

export default function useSelectColor() {
  const [selectedColor, setSelectedColor] = useState(null);

  const [variants, setVariants] = useAtom(productVariantsAtom);

  const setImages = useSetAtom(productImagesAtom);
  const setProductID = useSetAtom(productIdAtom);

  const selectColor = useCallback((id, sku, uid, images) => {
    setProductID(id);
    setSelectedColor(sku);
    setVariants([...variants, { sku, uid, attribute: 'v__rv' }]);
    setImages(images);
  }, []);

  useEffect(() => {
    if (variants?.length === 0) {
      setSelectedColor(null);
    }
  }, [variants]);

  return { selectedColor, selectColor };
}
